// extracted by mini-css-extract-plugin
export default {"oauth-dialog__container":"oauth-dialog_oauth-dialog__container__Gzeau","oauth-dialog__close-button":"oauth-dialog_oauth-dialog__close-button__BnFh1"};